export default "__VITE_ASSET__D8byoXBx__"